<template>
  <v-card v-if="showContentTypes" flat class="pa-3 py-6 rounded-lg">
    <v-row justify="center" align="center">
      <v-col
        v-for="(contentType, index) in contentTypes"
        :key="index"
        cols="auto"
      >
        <v-btn
          depressed
          plain
          :ripple="false"
          color="textLight"
          :disabled="disabled"
          class="body-2 font-weight-regular textLight--text text-capitalize"
          @click="onClick(contentType)"
        >
          <div class="d-flex flex-column align-center">
            <v-icon color="textLight">
              {{ getTrainingModuleContentTypeIcon({ contentType }) }}
            </v-icon>

            <p class="ma-0 mt-3">
              {{ contentType.toLowerCase() }}
            </p>
          </div>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>

  <v-btn
    v-else
    depressed
    block
    color="button"
    :disabled="disabled"
    class="
      subtitle-1
      font-weight-regular
      textLight--text
      text-capitalize
      rounded-lg
    "
    @click="showContentTypes = true"
  >
    <v-icon left size="20">mdi-plus</v-icon>

    {{ $t("course.courseDetails.addNewContent") }}
  </v-btn>
</template>

<script>
export default {
  name: "CourseContentAddButton",
  props: {
    contentTypes: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContentTypes: false,
    };
  },
  methods: {
    onClick(contentType) {
      this.showContentTypes = false;
      this.$emit("onClick", contentType);
    },
  },
};
</script>

<style scoped />
